import React, { Dispatch, SetStateAction } from 'react';
import {
    CommercialError,
    CommercialPayload,
    TransformedItems
} from '../../../../../../pages/dashboard/tradedocuments/tradeDocumentTypes/CommercialTypes';
import Quotefield from '../../../../../../pages/dashboard/tradedocuments/quotation/quotefield/quotefield';
import { SuitUIButton } from '../../../../../SuitUIButton';
import { Autocomplete, CircularProgress, MenuItem } from '@mui/material';
import CustomTextField from '../../../../../CustomTextInput';
import { formatDecimalNumber } from '../../../../../../utils/helper';
import { Currency } from '../../../../../../pages/dashboard/payments/interfaces/Currency';
import SignatureFields from '../../CommercialFomComponents/SignatureFields';

const StepThree = ({
    updateField,
    payload,
    setPartnerId,
    setShowAddPartner,
    errors,
    setSignatureUrlBase64,
    signatureUrlBase64,
    updateQuoteField,
    removeQuoteField,
    quoteFields,
    addQuoteField,
    loadingCurrencies,
    totalAmount,
    currencies
}: {
    updateField: (name: string, value: unknown) => void;
    payload: CommercialPayload;
    setPartnerId: Dispatch<SetStateAction<number | string | undefined>>;
    setShowAddPartner: Dispatch<SetStateAction<boolean>>;
    quoteFields: TransformedItems[];
    updateQuoteField: (
        index: number,
        attributeName: keyof TransformedItems,
        attributeValue: TransformedItems[keyof TransformedItems]
    ) => void;
    removeQuoteField: (index: number) => void;
    addQuoteField: () => void;
    setSignatureUrlBase64: (value: string) => void;
    signatureUrlBase64: string;
    errors: CommercialError;
    currencies: Currency[];
    totalAmount?: number;
    loadingCurrencies: boolean;
}) => {
    return (
        <div className='w-full flex flex-col gap-1'>
            {quoteFields.map((item, index) => (
                <Quotefield
                    item={item}
                    key={item.id}
                    index={index}
                    id={String(item.id)}
                    updateQuoteField={updateQuoteField}
                    price={item.price ?? 0}
                    qty={item.qty ?? 0}
                    removeQuoteField={removeQuoteField}
                />
            ))}

            <SuitUIButton
                text='Add field'
                onClick={addQuoteField}
                invert
                fullWidth
                style='px-[0.92rem] mt-4 text-[#00516A] font-medium text-sm leading-[20px] bg-[#E5F3F7]'
            />

            <div className=' flex flex-col gap-2'>
                <div>
                    <Autocomplete
                        value={payload.currencyCodeValue ?? undefined}
                        placeholder='Currency'
                        disableClearable
                        id='send-currency'
                        sx={{
                            marginTop: '.5rem',
                            '.MuiInputBase-input': {
                                height: '0.3rem'
                            }
                        }}
                        renderInput={(params) => (
                            <CustomTextField
                                params={params}
                                value={payload?.currencyCode}
                                label='Select Currency'
                                placeholder='Currency'
                                InputProps={{
                                    ...params.InputProps,
                                    endAdornment: loadingCurrencies && (
                                        <>
                                            <CircularProgress size={20} />
                                            {params.InputProps.endAdornment}
                                        </>
                                    )
                                }}
                            />
                        )}
                        noOptionsText={'No data available'}
                        renderOption={(props, option) => {
                            return (
                                <MenuItem
                                    {...props}
                                    value={option.name}
                                    key={`countries-${option.id}`}
                                >
                                    {option.name}
                                </MenuItem>
                            );
                        }}
                        getOptionLabel={(option) => option.name}
                        onChange={(event: any, value: any) => {
                            if (value !== null) {
                                updateField('currencyCode', value.currencyCode);
                                updateField('currencyCodeValue', value);
                            }
                        }}
                        options={currencies}
                    />
                </div>
                <div>
                    <CustomTextField
                        disabled
                        id='commercialinvoice-totalAmount'
                        label='Total Amount'
                        name='totalAmount'
                        value={formatDecimalNumber(totalAmount || 0)}
                    />
                </div>
            </div>

            <div className='border border-gray300 border-dashed mt-4' />
            <SignatureFields
                {...{
                    payload,
                    setPartnerId,
                    setShowAddPartner,
                    updateField,
                    errors,
                    setSignatureUrlBase64,
                    signatureUrlBase64
                }}
            />
        </div>
    );
};

export default StepThree;
